// NPM Imports
import React from "react";
import PropTypes from "prop-types";

const LZLoader = props => {
  const {
    className,
    fullScreen,
    label,
    theme,
    radius = "30",
    strokeWidth = "6",
  } = props;
  return (
    <div
      className={`lzloader-container ${
        fullScreen ? "lzloader-fullScreen" : ""
      } ${
        theme === "light" ? "lzloader-lightBg" : "lzloader-darkBg"
      } ${className} `}>
      <div className={className}>
        <svg className="svg-loader-class" width viewBox="0 0 66 66">
          <circle
            className="stroke-black-200 origin-center"
            fill="none"
            strokeWidth={strokeWidth}
            cx="33"
            cy="33"
            r={radius}
          />
          <circle
            className="spinner-path animate-spinner stroke-lz-brand origin-center"
            fill="none"
            strokeWidth={strokeWidth}
            cx="33"
            cy="33"
            r={radius}
          />
        </svg>
      </div>
      <span
        className={`lzloader-label ${
          theme === "light" ? "lzloader-darkLabel" : "lzloader-lightLabel"
        }`}>
        {label || null}
      </span>
    </div>
  );
};

LZLoader.defaultProps = {
  className: "",
  fullScreen: false,
  label: "",
  theme: "light",
};

LZLoader.propTypes = {
  className: PropTypes.string,
  fullScreen: PropTypes.bool,
  label: PropTypes.string,
  theme: PropTypes.string,
};

export default LZLoader;
